<template>
  <!-- 编辑、添加界面 -->
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="800px" :destroy-on-close="true"  :before-close="cancel">
    <w-table :columns="columns" :table-data="tableData" @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true"
             ref="wMyTable" :page="page" @pageChange="handlePagePagination" :isShowRowSelection="true">
    </w-table>
  </el-dialog>
</template>

<script>


import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export default {
  name: "ShowSalesMaterial",
  props:['showDialog','selectDetail'],
  data(){
    return{
      title:'销售物料信息详情展示',
      tableData:[],
      searchConditionTag:[],
      sortConditionTag:[],
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      },
    }
  },
  computed:{
    columns() {
      let filteredInfo = changeFilteredInfo([])
      return [
        {
          title: '物料名称',
          dataIndex: 'materialName',
          key: 'materialName',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            filtered: true,
          },
          filteredValue: filteredInfo.materialName || [],
        },
        {
          title: '物料数量',
          dataIndex: 'number',
          key: 'number',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            filtered: true,
          },
          filteredValue: filteredInfo.number || [],
        },
      ]
    }
  },
  watch:{
    selectDetail:{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.getData()
        }
      },
      immediate:true
    },
  },
  methods:{
    cancel(){
      this.$emit('submit','cancel')
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum;
      this.page.pageSize = page.pageSize;
      this.getData('');
    },
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData('search')
    },
    getData(type) {
      if (type) {
        this.page.currentNum = 1;
        this.page.pageSize = 10;
      }
      let data = Object.keys(this.selectDetail).filter(item => !['销售','销售经理','id'].includes(item)).map((key) => ({
        materialName:key,
        number: this.selectDetail[key],
      }))
      if(this.searchConditionTag.length){
        data = data.filter(item => {
          return this.searchConditionTag.every(condition => {
            return String(item[condition.key]).indexOf(String(condition.value)) !== -1;
          });
        });
      }
      this.tableData = data.map((item,index) => {
        return {
          id:index + 1,
          ...item
        }
      }).slice((this.page.currentNum-1)*this.page.pageSize,this.page.currentNum*this.page.pageSize);
      this.page.total = data.length
    },
  },

}
</script>

<style scoped>
</style>
